<template>
  <div>
    <v-progress-linear
      v-if="loading"
      :size="400"
      :width="10"
      color="#1E88E5"
      indeterminate
    ></v-progress-linear>
    <transition name="dashboard">
      <div v-if="!loading" class="main-div">
        <h1>Laporan Taawun</h1>

        <div class="footer mt-8">
          <v-btn color="success" large @click="dialog = true">
            <v-icon left>mdi-microsoft-excel</v-icon>
            Export Excel
          </v-btn>
        </div>

        <v-dialog v-model="dialog" max-width="700" scrollable>
          <subs-export v-if="dialog" @close-form="dialog = false" />
        </v-dialog>
      </div>
    </transition>
  </div>
</template>

<script>
import SubsExport from './components/subscription/SubsExport'
import ConstantMixin from '@/constantMixin'

export default {
  components: { SubsExport },
  mixins: [ConstantMixin],
  data() {
    return {
      loading: false,
      dialog: false
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-enter {
  opacity: 0;
  transform: translateX(-100px);
}
.dashboard-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.dashboard-enter-active {
  transition: all 0.3s ease-in;
}

.main-div {
  margin: 10px auto;
  width: 90%;
}

h1 {
  font-size: 1.5em;
  text-align: left;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
